import React, { useEffect, useCallback, useState} from 'react';
import accounts from 'accounts/Accounts.js';
import {connect} from 'react-redux';

const PendingComments = ({pendingComments}) => { 
    let [userName, setUserName] = useState('');

    useEffect(() => {
        accounts.getUserName()
            .then(setUserName);
    }, [setUserName]);
    let _pendingComments = [... pendingComments];
    _pendingComments.reverse();
    return _pendingComments.map(
        content => 
            <div>
              <div
                className="annotation">
                <div className="author">
                  {userName}: 
                </div>
                <div className="content">
                  {content}
                </div>
              </div>
            </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PendingComments);
